import { FETCH_SETTINGS_REQUEST_ASYNC as FETCH_GROUP_SETTINGS_REQUEST_ASYNC } from 'containers/GroupSettings/Wizard/constants'
import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  ADD_LANGUAGE,
  ANNOUNCEMENT_SELECT,
  DATA_REQUEST_ASYNC,
  LOCALE_DELETE_ASYNC,
  LOCALE_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {
      items: [],
      update: 0,
      activeIndex: 0,
      locale: {
        locale_id: 0,
      },
      selectedRecipients: {},
    },
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, items: [], loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: { ...state.data, items: action.payload.data },
          loader: false,
        }
      case FETCH_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: { ...state.data, items: action.payload.data?.endUserAlerts },
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case LOCALE_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          data: {
            ...state.data,
            locale: { locale_id: action.payload.data.locale_id },
          },
        }
      case LOCALE_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...state.data,
            locale: { ...state.data.locale, ...action.payload.data },
            selectedRecipients: action.payload.data.data.participants || {},
          },
        }
      case LOCALE_DELETE_ASYNC.SUCCESS: {
        const newState = { ...state }
        const locales = newState.data.items[state.data.activeIndex].locales
        const localeId = action.payload.data.locale_id
        const i = locales.indexOf(localeId)
        if (i !== -1) {
          newState.data.items[state.data.activeIndex].locales.splice(i, 1)
        }
        if (locales[0]) {
          newState.data.locale.locale_id = locales[0]
        }
        return newState
      }
      case ANNOUNCEMENT_SELECT: {
        const activeIndex = action.payload.itemIndex
        return {
          ...state,
          data: {
            ...state.data,
            activeIndex,
            locale: {
              ...state.data.locale,
              locale_id: state.data.items[activeIndex].locales[0],
            },
          },
        }
      }
      case ADD_LANGUAGE: {
        const newState = { ...state }
        newState.data.items[state.data.activeIndex].locales.push(action.payload.id)
        newState.data.locale = {
          ...state.data.locale,
          locale_id: action.payload.id,
        }
        return newState
      }
      default:
        return state
    }
  }
}
